import React, { useState, useEffect } from 'react';
import './SurveyResponsesSurveyDistributionList.css';
import SurveyResponsesSurveyDistributionCard from './SurveyResponsesSurveyDistributionCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';
import { format, parseISO } from 'date-fns';
import Pager from '../Pager/Pager';

const DISTRIBUTIONS_PER_PAGED_VIEW = 4;

export default function SurveyResponsesSurveyDistributionList({ distributions, onSelect, fullWidth, selectedDistribution, onPageChanged }) {
  const [searchTerms, setSearchTerms] = useState('');
  const [visibleDistributions, setVisibleDistributions] = useState(distributions);
  const [currentPage, setCurrentPage] = useState(1);

  if (logComponent('SurveyResponsesSurveyDistributionList')) { console.debug('SurveyResponsesSurveyDistributionList rendered'); }


  useEffect(() => {
    if (logComponent('SurveyResponsesSurveyDistributionList')) { console.debug('SurveyResponsesSurveyDistributionList useEffect  [distributions, searchTerms]'); }
    updateVisibleDistributions();
  }, [distributions, searchTerms])


  const updateSearchTerms = (e) => {
    if (logComponent('SurveyResponsesSurveyDistributionList')) { console.debug('SurveyResponsesSurveyDistributionList updateSearchTerms'); }
    setSearchTerms(e.target.value);
  }


  const updateVisibleDistributions = () => {
    if (logComponent('SurveyResponsesSurveyDistributionList')) { console.debug('SurveyResponsesSurveyDistributionList updateVisibleDistributions'); }

    if (distributions) {
      let filteredDistributions = distributions.filter(collection => {
        let formattedSendOn = format(parseISO(collection.sendOn), 'MM/dd/yyyy');
        let formattedExpiresOn = format(parseISO(collection.expiresOn), 'MM/dd/yyyy');
        return collection.message.toLowerCase().includes(searchTerms.toLowerCase()) ||
          formattedSendOn.includes(searchTerms.toLowerCase()) ||
          formattedExpiresOn.includes(searchTerms.toLowerCase())
          ;


      });

      setVisibleDistributions(filteredDistributions);
    }
  }

  const updateSelectedSurveyDistribution = (surveyDistribution) => {
    if (logComponent('SurveyResponsesSurveyDistributionList')) { console.debug('SurveyResponsesSurveyDistributionList updateSelectedSurveyDistribution'); }
    onSelect(surveyDistribution);
  }

  const selectPage = (surveyPage) => {
    if (logComponent('SurveyResponsesSurveyDistributionList')) { console.debug('SurveyResponsesSurveyDistributionList selectSurveyPage'); }
    if (selectedDistribution && visibleDistributions && visibleDistributions.length > 0) {
      let newSelectedDistribution = visibleDistributions.slice((surveyPage - 1) * DISTRIBUTIONS_PER_PAGED_VIEW, surveyPage * DISTRIBUTIONS_PER_PAGED_VIEW)[0];
      onSelect(newSelectedDistribution);
      onPageChanged(newSelectedDistribution)
    }
    setCurrentPage(surveyPage);
  }


  return (
    visibleDistributions &&
    <div className={'Survey-Response-Survey-Distribution-List' + (fullWidth ? ' Survey-Response-Survey-Distribution-List--full-width' : '')}>
      <div className="Survey-Response-Survey-Distribution-List__search-wrapper">
        <FontAwesomeIcon icon="search" className="Survey-Response-Survey-Distribution-List__search-icon" />
        <input
          type="text"
          className="Survey-Response-Survey-Distribution-List__search-input"
          placeholder="Search distributions"
          value={searchTerms}
          onChange={updateSearchTerms} />
      </div>
      <ul className="Survey-Response-Survey-Distribution-List__distributions">
        {
          visibleDistributions
            .slice((currentPage - 1) * DISTRIBUTIONS_PER_PAGED_VIEW, currentPage * DISTRIBUTIONS_PER_PAGED_VIEW)
            .map(surveyDistribution =>
              <SurveyResponsesSurveyDistributionCard
                key={surveyDistribution.surveyDistributionId}
                surveyDistribution={surveyDistribution}
                onClick={updateSelectedSurveyDistribution}
                selected={!fullWidth ? surveyDistribution.surveyDistributionId === (selectedDistribution?.surveyDistributionId ?? -1) : false} />
            )
        }
      </ul>
      <div className="Survey-Response-Survey-Distribution-List__pager">
        <Pager

          items={visibleDistributions.length}
          onChange={selectPage}
          selectedPage={currentPage}
          pageSize={DISTRIBUTIONS_PER_PAGED_VIEW}
        />
      </div>
      {
        !visibleDistributions ||
        (visibleDistributions &&
          visibleDistributions.length === 0) &&
        <p className="Survey-Response-Survey-Distribution-List__empty-message">No distributions found...</p>
      }
    </div>
  );
}